function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM6.83871 11.0968H7.22581V7.22581H6.83871C6.62494 7.22581 6.45161 7.05248 6.45161 6.83871V6.58065C6.45161 6.36687 6.62494 6.19355 6.83871 6.19355H8.3871C8.60087 6.19355 8.77419 6.36687 8.77419 6.58065V11.0968H9.16129C9.37506 11.0968 9.54839 11.2701 9.54839 11.4839V11.7419C9.54839 11.9557 9.37506 12.129 9.16129 12.129H6.83871C6.62494 12.129 6.45161 11.9557 6.45161 11.7419V11.4839C6.45161 11.2701 6.62494 11.0968 6.83871 11.0968ZM8 3.35484C7.4299 3.35484 6.96774 3.817 6.96774 4.3871C6.96774 4.95719 7.4299 5.41935 8 5.41935C8.5701 5.41935 9.03226 4.95719 9.03226 4.3871C9.03226 3.817 8.5701 3.35484 8 3.35484Z"
});

var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-circle.7621098e.svg";
export { ForwardRef as ReactComponent };